import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, Optional, OnDestroy } from '@angular/core';
import { PhxNavigationButtonBackground, PhxNavigationButtonSize } from './phx-navigation-button.types';
import { ChevronLeft, ChevronRight } from './../icon/icon-map';
import { PHX_SIZE, PHX_BACKGROUND } from '../../constants';
import { PhxContextService, PHOENIX_CONTEXTS } from '../../services/phx-context-service';

@Component({
  selector: 'phx-navigation-button',
  templateUrl: './phx-navigation-button.component.html',
  styleUrls: ['./phx-navigation-button.component.scss'],
  host: {
    class: 'phx-navigation-button',
    '[class.phx-navigation-button-extra-small]': 'phxSize === PHX_SIZE.XS',
    '[class.phx-navigation-button-small]': 'phxSize === PHX_SIZE.SM',
    '[class.phx-navigation-button-medium]': 'phxSize === PHX_SIZE.MD',
    '[class.phx-navigation-button-large]': 'phxSize === PHX_SIZE.LG',
    '[class.phx-navigation-button-hide-content]': 'phxHideNavigationContent',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxNavigationButtonComponent implements OnDestroy {
  @Input() public phxLeftNavigationDisabled: boolean = false;
  @Input() public phxRightNavigationDisabled: boolean = false;
  @Input() public phxLoading: boolean = false;
  @Input() public phxHideNavigationContent: boolean = false;
  @Input() public phxSize: PhxNavigationButtonSize = PHX_SIZE.MD;
  @Input() public phxBackground: PhxNavigationButtonBackground = PHX_BACKGROUND.STANDARD;
  @Input() public phxPrefixIcon: string = ChevronLeft;
  @Input() public phxSuffixIcon: string = ChevronRight;

  @Output() public phxOnLeftNavigation: EventEmitter<Event> = new EventEmitter();
  @Output() public phxOnRightNavigation: EventEmitter<Event> = new EventEmitter();

  public readonly PHX_SIZE = PHX_SIZE;
  public readonly PHX_ICON_SIZE_XS = 16;
  public readonly PHX_ICON_SIZE_DEFAULT = 20

  private readonly _destroy$ = new Subject<void>();

  
  constructor(private _cdr: ChangeDetectorRef, @Optional() private _contextService: PhxContextService) {
    this._initContainerContext();
  }
  
  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
  
  
  private updateSize(size: PhxNavigationButtonSize): void {
    this.phxSize = size;
    this._cdr.markForCheck();
  }
  
  /** Subscribes to the container context size map if this component is inside a container (e.g. phx-overview). */
  private _initContainerContext(): void {
    if (this._contextService?.getType() !== PHOENIX_CONTEXTS.CONTAINER_COMPONENT) {
      return;
    }
    const containerService = this._contextService;
    containerService.sizeMap$.pipe(takeUntil(this._destroy$)).subscribe(sizeMap => {
      const size = containerService.getSizeForSelector(sizeMap, 'phx-navigation-button') as PhxNavigationButtonSize | null;
      if (size) {
        this.updateSize(size);
      }
    });
  }
}
